'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _checkbox = require('./checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Checkbox.Group */
var CheckboxGroup = function (_Component) {
    (0, _inherits3.default)(CheckboxGroup, _Component);

    function CheckboxGroup(props) {
        (0, _classCallCheck3.default)(this, CheckboxGroup);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxGroup.__proto__ || (0, _getPrototypeOf2.default)(CheckboxGroup)).call(this, props));

        var value = [];
        if ('value' in props) {
            value = props.value;
        } else if ('defaultValue' in props) {
            value = props.defaultValue;
        }
        if (!Array.isArray(value)) {
            if (value === null || value === undefined) {
                value = [];
            } else {
                value = [value];
            }
        }
        _this.state = {
            value: [].concat((0, _toConsumableArray3.default)(value)),
            disabled: props.disabled
        };

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(CheckboxGroup, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                __group__: true,
                onChange: this.onChange,
                selectedValue: this.state.value,
                disabled: this.state.disabled
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                var value = nextProps.value;

                if (!Array.isArray(value)) {
                    if (value === null || value === undefined) {
                        value = [];
                    } else {
                        value = [value];
                    }
                }
                this.setState({
                    value: value
                });
            }
            if ('disabled' in nextProps) {
                this.setState({
                    disabled: nextProps.disabled
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(currentValue, e) {
            var value = this.state.value;

            var index = (0, _util.isCheckedIndex)(value, currentValue);
            var valTemp = [].concat((0, _toConsumableArray3.default)(value));

            if (index === -1) {
                valTemp.push(currentValue);
            } else {
                valTemp.splice(index, 1);
            }

            if (!('value' in this.props)) {
                this.setState({ value: valTemp });
            }
            this.props.onChange(valTemp, e);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this,
                _classnames;

            var _props = this.props,
                className = _props.className,
                style = _props.style;

            var disabled = this.state.disabled;
            var prefix = this.context.prefix || this.props.prefix;

            // 如果内嵌标签跟dataSource同时存在，以内嵌标签为主
            var children = void 0;
            if (this.props.children) {
                children = this.props.children;
            } else {
                children = this.props.dataSource.map(function (item, index) {
                    var option = item;
                    if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) !== 'object') {
                        option = {
                            label: item,
                            value: item,
                            disabled: disabled
                        };
                    }
                    var checked = _this2.state.value && (0, _util.isChecked)(_this2.state.value, option.value);

                    return _react2.default.createElement(
                        'label',
                        { key: index },
                        _react2.default.createElement(_checkbox2.default, {
                            value: option.value,
                            checked: checked,
                            disabled: disabled || option.disabled
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: prefix + 'checkbox-label' },
                            option.label
                        )
                    );
                });
            }

            var cls = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, prefix + 'checkbox-group', true), (0, _defineProperty3.default)(_classnames, className, !!className), (0, _defineProperty3.default)(_classnames, 'disabled', disabled), _classnames));

            return _react2.default.createElement(
                'span',
                { className: cls, style: style },
                children
            );
        }
    }]);
    return CheckboxGroup;
}(_react.Component);

CheckboxGroup.propTypes = {
    /**
     * 样式类名的品牌前缀
     */
    prefix: _propTypes2.default.string,
    /**
     * 自定义类名
     */
    className: _propTypes2.default.string,
    /**
     * 自定义内敛样式
     */
    style: _propTypes2.default.object,
    /**
     * 整体禁用
     */
    disabled: _propTypes2.default.bool,
    /**
     * 可选项列表, 数据项可为 String 或者 Object, 如 `['apple', 'pear', 'orange']` 或者 `[{value: 'apple', label: '苹果',}, {value: 'pear', label: '梨'}, {value: 'orange', label: '橙子'}]`
     */
    dataSource: _propTypes2.default.arrayOf(_propTypes2.default.any),
    /**
     * 被选中的值列表
     */
    value: _propTypes2.default.array,
    /**
     * 默认被选中的值列表
     */
    defaultValue: _propTypes2.default.array,
    /**
     * 通过子元素方式设置内部 checkbox
     */
    children: _propTypes2.default.arrayOf(_propTypes2.default.element),
    /**
     * 选中值改变时的事件
     * @param {Array} value 选中项列表
     * @param {Event} e Dom 事件对象
     */
    onChange: _propTypes2.default.func
};
CheckboxGroup.defaultProps = {
    dataSource: [],
    onChange: function onChange() {},
    prefix: 'next-'
};
CheckboxGroup.contextTypes = {
    prefix: _propTypes2.default.string
};
CheckboxGroup.childContextTypes = {
    onChange: _propTypes2.default.func,
    __group__: _propTypes2.default.bool,
    selectedValue: _propTypes2.default.array,
    disabled: _propTypes2.default.bool
};
exports.default = CheckboxGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-checkbox@0.0.1@@alicd/crui-checkbox/lib/checkbox-group.js
// module id = 609
// module chunks = 0